export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceDeliveryTypeInfo: {
        deliveryTypeName: "xxxxxx",
        deliveryType: "xxxxxx",
        deliveryPriority: "xxxxxx",
      },
      ServiceDeliveryPeriods: [
        {
          serviceDeliveryPeriodId: 1,
          serviceDeliveryPeriodUUid: "xxxxxx",
          deliveryFrequencyKbn: 1,
          deliveryToKbn: 2,
          deliveryPeriodDays: 30,
          deliveryStartTime: "xxxxx",
          deliveryEndTime: "xxxxx"
        }
      ]
    }
  }
}